import {
  ApiCashoutOperationStatus,
  GetOperationRequestDto,
  GetOperationResponseDto,
  ResendEmailRequestDto,
} from '@paypoint-frontend/paynet-spa-wallet-customer-contracts/ecomcashout';
import { ErrorResponseDto } from '@paypoint-frontend/paynet-spa-wallet-customer-contracts';
import {
  CashoutOperation,
  CashoutOperationError,
  CashoutOperationStatus,
  ResendEmail,
} from './model';

export function mapGetOperationToGetOperationRequestDto(
  paymentId: number,
  signature: string,
): GetOperationRequestDto {
  return {
    paymentId,
    signature,
  };
}

export function mapGetOperationResponseDtoToCashoutOperation(
  dto: GetOperationResponseDto,
): CashoutOperation {
  return {
    id: dto.Id,
    regDate: dto.RegDate,
    expirationDate: dto.ExpirationDate,
    payDate: dto.PayDate,
    cashoutCode: dto.CashoutCode,
    cashoutStatus: mapCashoutOperationStatus(dto.CashoutStatus),
    merchantCode: dto.MerchantCode ?? '',
    merchantName: dto.MerchantName ?? '',
    saleAreaId: dto.SaleAreaId,
    amountMdl: dto.AmountMdl,
    email: dto.Email ?? '',
    logoCode: dto.LogoCode ?? '',
    successUrl: dto.SuccessURL ?? '',
    cancelUrl: dto.CancelURL ?? '',
    description: dto.Description ?? '',
  };
}

export function mapResendEmailToResendEmailRequestDto(
  model: ResendEmail,
): ResendEmailRequestDto {
  return {
    OperationId: model.operationId,
    Email: model.email,
  };
}

export function mapErrorResponseDtoToCashoutOperationError(
  dto: ErrorResponseDto,
): CashoutOperationError {
  return {
    resultCode: dto.Code,
    resultMessage: dto.Message,
  };
}

function mapCashoutOperationStatus(
  status: ApiCashoutOperationStatus,
): CashoutOperationStatus {
  switch (status) {
    case ApiCashoutOperationStatus.PaymentCreated:
      return CashoutOperationStatus.PAYMENT_CREATED;
    case ApiCashoutOperationStatus.Completed:
      return CashoutOperationStatus.COMPLETED;
    case ApiCashoutOperationStatus.Error:
      return CashoutOperationStatus.ERROR;
    case ApiCashoutOperationStatus.Expired:
      return CashoutOperationStatus.EXPIRED;
    case ApiCashoutOperationStatus.Initiated:
    default:
      return CashoutOperationStatus.INITIATED;
  }
}
